import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { MethodLogosDeleteDialog } from 'pages/MethodLogos/components/MethodLogosDeleteDialog';
import { useShowController } from 'react-admin';
import { DeleteButton, EditLinkButton } from 'shared/mui/Buttons';
import { UserActionsIconButton } from 'shared/mui/IconButtons/UserActionsIconButton/UserActionsIconButton';
import { ShowPage } from 'shared/react-admin/Pages/ShowPage/ShowPage';
import { MethodLogosShowDialogTable } from 'shared/widgets/MethodLogosShowDialog/MethodLogosShowDialogTable';
import { MethodLogo } from 'types/embedded/methodLogo';
import { Permission } from 'types/embedded/permission';

export const MethodLogosShow: React.FC = () => {
  const { hasResourcePermissions, hasResourceAccess } = usePermissions();
  const { record } = useShowController();

  const { handleCloseRecordModal, openRecordModal, handleOpenRecordModal } =
    useRecordModal<MethodLogo>();

  return (
    <>
      <ShowPage
        actions={
          hasResourceAccess(Resources.UserActions) && (
            <UserActionsIconButton entityName="method_logo" />
          )
        }
        listName="Логотипы методов"
        rightActionsSlot={[
          hasResourcePermissions(Resources.MethodLogos, [Permission.Full, Permission.Delete]) && (
            <DeleteButton
              label="Удалить"
              onClick={() => handleOpenRecordModal()}
              variant="outlined"
            />
          ),
          hasResourcePermissions(Resources.MethodLogos, [Permission.Full, Permission.Update]) && (
            <EditLinkButton variant="contained" />
          ),
        ]}
        title="Просмотр логотипа"
      >
        <MethodLogosShowDialogTable />
      </ShowPage>
      {openRecordModal && (
        <MethodLogosDeleteDialog
          onClose={handleCloseRecordModal}
          open={openRecordModal}
          record={record}
        />
      )}
    </>
  );
};
